import * as React from 'react';
export const IcGladiator = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 7a6.5 6.5 0 00-6.5 6.5v.5h4.06a.51.51 0 11.2 1L5.5 16.79v2.7A2 2 0 008 21.43l8.22-1.89a3.001 3.001 0 002.33-2.93V13.5A6.498 6.498 0 0012 7zm9.84 3.26A10 10 0 003 7.72 1 1 0 003.26 9l.58.45a1 1 0 001.45-.26 8 8 0 017.53-3.62 8.08 8.08 0 017 6.5c.195 1.3.255 2.617.18 3.93a2.87 2.87 0 001.83-2.18 9.669 9.669 0 00.01-3.56z'
      fill='currentColor'
    />
  </svg>
);
